import { render } from "./InformationCardTemplate.vue?vue&type=template&id=2aa3a74c"
import script from "./InformationCardTemplate.vue?vue&type=script&lang=js"
export * from "./InformationCardTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/chart_templates/InformationCardTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2aa3a74c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2aa3a74c', __exports__)) {
    api.reload('2aa3a74c', __exports__)
  }
  
  module.hot.accept("./InformationCardTemplate.vue?vue&type=template&id=2aa3a74c", () => {
    api.rerender('2aa3a74c', render)
  })

}


export default __exports__